import * as mixpanel from 'mixpanel-browser';

// Check for PROD node env
const isLocal = process.env.REACT_APP_ENVIRONMENT === 'local';

// eslint-disable-next-line no-console
console.log(process.env.REACT_APP_ENVIRONMENT);

mixpanel.init(
  isLocal
    ? '33dd0e2772383f97ce562901245220cd'
    : '2b08d81437d3be618bd226a652d586be',
  {
    debug: process.env.REACT_APP_ENVIRONMENT === 'local',
    ignore_dnt: true,
  },
);

export const trackLandingPagePageView = () => {
  track('PV - Landing Page');
};

export const trackLandingPageGetStartedButtonTapped = (
  buttonDescrip: string,
) => {
  track('Landing Page Get Started Button Tapped', { buttonDescrip });
};

export const trackOnboardingCollectedGender = (gender: string | null) => {
  track('Onboarding Collected Gender', { gender });
};

export const trackOnboardingCollectedGoals = (goals: string[]) => {
  track('Onboarding Collected Goals', { goals });
};

export const trackOnboardingCollectedMotivations = (motivations: string[]) => {
  track('Onboarding Collected Motivations', { motivations });
};

export const trackOnboardingCollectedFitnessLevel = (
  fitnessLevel: string | null,
) => {
  track('Onboarding Collected Fitness Level', { fitnessLevel });
};

export const trackOnboardingCollectedRunningHistory = (
  runningHistory: string | null,
) => {
  track('Onboarding Collected Running History', { runningHistory });
};

export const trackOnboardingCollectedWalkingTime = (
  walkingTime: string | null,
) => {
  track('Onboarding Collected Walking Time', { walkingTime });
};

export const trackOnboardingCollectedEndurance = (endurance: string | null) => {
  track('Onboarding Collected Endurance', { endurance });
};

export const trackOnboardingCollectedBaselineSpeedReaction = (
  baselineSpeedDescrip: string,
  reactionTitle: string | null,
) => {
  track('Onboarding Collected Baseline Speed Reaction', {
    baselineSpeedDescrip,
    reactionTitle,
  });
};

export const trackOnboardingCollectedMusic = (musicGenres: string[]) => {
  track('Onboarding Collected Music', { musicGenres });
};

export const trackBuildingProfilePageView = () => {
  track('PV - Building Profile');
};

export const trackBuildingProfileContinueButtonTapped = () => {
  track('Building Profile Continue Button Tapped');
};

export const trackSendToAppPageView = () => {
  track('PV - Send To App');
};

export const trackShareCodePageView = (shareCodValue?: string) => {
  track('PV - Share Code', { shareCodValue });
};

export const trackSendToAppDownloadButtonTapped = (
  source: string,
  shareCodValue?: string,
) => {
  track('Send To App Download Button Tapped', { source, shareCodValue });
};

export const trackSendToAppDeepLinkButtonTapped = (url: string) => {
  track('Send To App Deep Link Button Tapped', { url });
};

const track = (event: string, properties?: any) => {
  mixpanel.track(event, properties, { send_immediately: true }, () => {
    // console.log('Mixpanel track result:', result);
  });
};
